require('./filterFormController');
require('../../../../shared/clipSearch/filterFormDirective/filterFormDirective');

angular.module('app.admin.videoAnalysis.tabs.filterForm', [
  'app.admin.videoAnalysis.tabs.filterForm.filterFormController',
  'app.shared.clipSearch.filterFormDirective'
])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      "use strict";

      $stateProvider.state(
        'app.admin.videoAnalysis.filterForm',
        {
          url: '/filter?:filter',
          templateUrl: 'components/admin/videoAnalysis/tabs/filterForm/filterFormView.html',
          controller: 'app.admin.videoAnalysis.tabs.filterForm.filterFormController',
          isChildState: true,
          params: {
            preset: null,
          }
        }
      )
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/videoAnalysis/tabs/filterForm/filterForm.js